/** Convert HSL (hue 0-360, s/l 0-100) to exceljs ARGB string `FFRRGGBB`. */
export function hslToArgb(h: number, s: number, l: number): string {
    const sNorm = s / 100;
    const lNorm = l / 100;
    const c = (1 - Math.abs(2 * lNorm - 1)) * sNorm;
    const hPrime = h / 60;
    const x = c * (1 - Math.abs((hPrime % 2) - 1));

    let r1 = 0;
    let g1 = 0;
    let b1 = 0;

    if (hPrime >= 0 && hPrime < 1) {
        r1 = c; g1 = x; b1 = 0;
    } else if (hPrime >= 1 && hPrime < 2) {
        r1 = x; g1 = c; b1 = 0;
    } else if (hPrime >= 2 && hPrime < 3) {
        r1 = 0; g1 = c; b1 = x;
    } else if (hPrime >= 3 && hPrime < 4) {
        r1 = 0; g1 = x; b1 = c;
    } else if (hPrime >= 4 && hPrime < 5) {
        r1 = x; g1 = 0; b1 = c;
    } else if (hPrime >= 5 && hPrime < 6) {
        r1 = c; g1 = 0; b1 = x;
    }

    const m = lNorm - c / 2;
    const r = Math.round((r1 + m) * 255);
    const g = Math.round((g1 + m) * 255);
    const b = Math.round((b1 + m) * 255);

    return `FF${toHex(r)}${toHex(g)}${toHex(b)}`;
}

function toHex(n: number): string {
    return n.toString(16).padStart(2, '0').toUpperCase();
}

const HSL_REGEX = /^hsl\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%\s*\)$/i;

export function cssColorToArgb(color: string): string {
    if (color === 'black') return 'FF000000';
    if (color === 'white') return 'FFFFFFFF';

    const match = HSL_REGEX.exec(color.trim());
    if (!match) {
        throw new Error(`Unsupported CSS color: ${color}`);
    }
    return hslToArgb(Number(match[1]), Number(match[2]), Number(match[3]));
}
